<template>
	<div :class="['zone-indicator', stateClassName]" data-test="zoneIndicator">
		<router-link
			v-if="hasZonePermission"
			class="zone-indicator__link"
			:to="{ path: '/environments' }"
			data-test="zoneIndicatorPermission"
		>
			{{ message }}
		</router-link>
		<span
			v-else
			class="zone-indicator__text"
			data-test="zoneIndicatorNoPermission"
		>
			{{ message }}
		</span>
	</div>
</template>

<script>
export default {
	name: 'ZoneIndicator',
	props: {
		message: {
			type: String,
			default: ''
		},
		environmentId: [Number, String],
		hasZonePermission: {
			type: Boolean,
			default: false
		},
		state: {
			type: String,
			default: '',
			validator(value) {
				return [
					'',
					'zone-1',
					'zone-2',
					'zone-3',
					'zone-4',
					'zone-5'
				].includes(value);
			}
		}
	},
	computed: {
		stateClassName() {
			return this.state;
		}
	}
};
</script>

<style lang="scss" scoped>
.zone-indicator {
	width: calc(
		100% + $padding-md
	); // uses padding variable to equally counter the card style
	margin-top: $gutter-md;
	margin-left: -$padding-sm; // uses padding variable to equally counter the card style
	margin-bottom: -$padding-sm; // uses padding variable to equally counter the card style
	@include body-text('sm');
	line-height: 1;
	text-align: center;
	text-transform: capitalize;

	&__text,
	&__link {
		display: block;
		padding: $padding-xs;
	}
}
</style>
